module.exports = __webpack_public_path__ + "img/symbol-infinity-left.fc13c5f3.png";